// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"572":"71ebe787","853":"f61aca1c"}[chunkId] + ".chunk.js";
};